/**
 * Hook composing the CUBK card's "Action required" state.
 *
 * Returns hasEffectiveActionRequired (active bookkeeper followup, OR ≥1
 * visible BK-blocking item). "Visible" excludes
 * CLARIFY_UNCATEGORIZED_TRANSACTIONS unless needed, keeping badge and banner
 * in sync.
 *
 * Note: CLARIFY_UNCATEGORIZED_TRANSACTIONS is additionally gated behind
 * followupRequestedAt in selectBlockingItemsAlertData — it only surfaces after
 * the bookkeeper triggers Request CUBK Followup. This prevents the action item
 * from appearing prematurely during the BK team review phase.
 */
import { useReselector } from '@/utils/sharedHooks'
import {
  selectHasActionRequired,
  selectHasIncompleteBlockingItems,
} from '../cubk.selectors'

export interface UseHasEffectiveActionRequiredResult {
  hasEffectiveActionRequired: boolean
}

export const useHasEffectiveActionRequired =
  (): UseHasEffectiveActionRequiredResult => {
    const hasFollowupActionRequired = useReselector(selectHasActionRequired)
    const hasIncompleteBlockingItems = useReselector(
      selectHasIncompleteBlockingItems
    )

    return {
      hasEffectiveActionRequired:
        hasFollowupActionRequired || hasIncompleteBlockingItems,
    }
  }
